import { loadStateFilter } from '../../AsyncLoader';

/**
 * @param {import('./StateFilter').StateFilterConfig} config 
 */
async function register(config) {
  const StateFilter = await loadStateFilter();

  return new StateFilter(config);
}

export {
  register,
};


// WEBPACK FOOTER //
// ./V7/tnew/lib/StateFilterRegistration.js